/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef, useState } from 'react'
import { normalizeAccents } from 'bam-node-baseball-savant/utils/normalize-accents'

import type Swing from './types/Swing'

type PlayerSearchProps = {
    onAdd: (item: Swing) => void
    swings: Swing[]
    relevantSwings: Swing[]
}

const PAGE_SIZE = 8

export default function PlayerSearch({
    onAdd,
    swings,
    relevantSwings,
}: PlayerSearchProps) {
    const years = [...new Set(swings.map((d) => d.year))].sort().reverse()

    const ref = useRef<HTMLDivElement>(null)
    const [yearFilter, setYearFilter] = useState('')
    const [batSideFilter, setBatSideFilter] = useState('')
    const [searchFilter, setSearchFilter] = useState('')
    const [pageNumber, setPageNumber] = useState(0)
    const [showIrrelevant, setShowIrrelevant] = useState(false)

    const hasRelevant = Boolean(relevantSwings.length)
    const chosenSwings =
        showIrrelevant || !hasRelevant ? swings : relevantSwings

    const needle = normalizeAccents(searchFilter)
    const filtered = chosenSwings
        .filter((d) => {
            if (yearFilter === '') {
                return true
            }

            return d.year === Number(yearFilter)
        })
        .filter((d) => {
            if (batSideFilter === '') {
                return true
            }

            return d.batSide === batSideFilter
        })
        .filter((d) => {
            if (searchFilter === '') {
                return true
            }

            const haystack = normalizeAccents(d.name)

            return haystack.includes(needle)
        })

    const sliced = filtered.slice(
        pageNumber * PAGE_SIZE,
        pageNumber * PAGE_SIZE + PAGE_SIZE
    )

    const pages = Math.ceil(filtered.length / PAGE_SIZE)

    function handleSelect(d: Swing) {
        if (ref.current) {
            ref.current.hidePopover()
        }

        onAdd(d)
    }

    function handleFilter(type: 'year' | 'batSide' | 'search', value: string) {
        switch (type) {
            case 'year':
                setYearFilter(value)
                break
            case 'batSide':
                setBatSideFilter(value)
                break
            case 'search':
            default:
                setSearchFilter(value)
                break
        }

        setPageNumber(0)
    }

    const prevPage = pageNumber !== 0
    const nextPage = pageNumber + 1 !== pages

    return (
        <>
            <button
                type="button"
                {...({
                    popovertarget: 'player-search',
                } as React.HTMLAttributes<HTMLButtonElement>)}
                className="add-player-button video-viz-border"
            >
                <img
                    src="https://content.mlb.com/images/headshots/current/60x60/generic.png"
                    alt="Add a Player"
                    width="60"
                    height="60"
                    style={{
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    }}
                />
                {/* <div style={{ fontSize: "24px" }}>+</div> */}
                <div
                    style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        margin: '10px auto 5px',
                    }}
                >
                    Add Player
                </div>
            </button>
            <div
                {...({
                    popover: 'auto',
                } as React.HTMLAttributes<HTMLDivElement>)}
                id="player-search"
                ref={ref}
                style={{
                    height: '670px',
                    maxHeight: '90%',
                    maxWidth: '500px',
                    width: '90%',
                    background: 'whitesmoke',
                }}
            >
                <h1>Add A Player</h1>
                <div
                    className="form-group"
                    style={{ display: 'flex', gap: '0.5rem' }}
                >
                    <div
                        className="savant-select"
                        data-title="Year"
                        style={{ flexBasis: '50%' }}
                    >
                        <select
                            id="ddlYearPlayerSearch"
                            value={yearFilter}
                            onChange={(e) =>
                                handleFilter('year', e.target.value)
                            }
                        >
                            <option value="">Any</option>
                            {years.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div
                        className="savant-select"
                        data-title="Bat Side"
                        style={{ flexBasis: '50%' }}
                    >
                        <select
                            id="ddlBatSidePlayerSearch"
                            value={batSideFilter}
                            onChange={(e) =>
                                handleFilter('batSide', e.target.value)
                            }
                        >
                            <option value="">Any</option>
                            <option value="L">LHB</option>
                            <option value="R">RHB</option>
                        </select>
                    </div>
                </div>
                {hasRelevant && (
                    <div>
                        <input
                            id="irrelevant-checkbox"
                            type="checkbox"
                            checked={showIrrelevant}
                            onChange={() => {
                                setShowIrrelevant(!showIrrelevant)
                                setPageNumber(0)
                            }}
                        />
                        <label
                            htmlFor="irrelevant-checkbox"
                            style={{
                                fontWeight: 'normal',
                                marginLeft: '6px',
                                fontFamily: 'Roboto Condensed',
                                color: '#777',
                            }}
                        >
                            Show All Available Swings
                        </label>
                    </div>
                )}
                <div>
                    <input
                        className="form-control"
                        style={{ height: '32px', marginBottom: '15px' }}
                        type="text"
                        value={searchFilter}
                        onChange={(e) => handleFilter('search', e.target.value)}
                        placeholder="Search by player name"
                    />
                </div>
                <div>
                    {sliced.map((d) => {
                        const imageSize = 45
                        return (
                            <div
                                key={d.id}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderBottom: '1px solid #ccc',
                                    background: 'white',
                                    padding: '0.2rem 0',
                                }}
                                onClick={() => handleSelect(d)}
                            >
                                <img
                                    alt={d.name}
                                    src={`https://midfield.mlbstatic.com/v1/people/${
                                        d.playerId
                                    }/spots/${imageSize * 3}`}
                                    height={imageSize * 1}
                                    width={imageSize * 1}
                                />
                                <div
                                    style={{
                                        fontSize: '1.3rem',
                                        flexGrow: 2,
                                        margin: '0 1rem',
                                    }}
                                >
                                    {d.name}
                                </div>
                                <div>{d.year}</div>
                                <div
                                    style={{
                                        textAlign: 'right',
                                        width: '60px',
                                        paddingRight: '10px',
                                    }}
                                >
                                    {d.batSide === 'L' ? 'LHB' : 'RHB'}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div style={{ textAlign: 'center', margin: '1rem' }}>
                    <button
                        type="button"
                        onClick={() => setPageNumber(pageNumber - 1)}
                        disabled={!prevPage}
                        style={{
                            cursor: prevPage ? 'pointer' : 'not-allowed',
                        }}
                    >
                        ←
                    </button>
                    <span style={{ display: 'inline-block', margin: '0 1rem' }}>
                        Page {pageNumber + 1}
                    </span>
                    <button
                        type="button"
                        onClick={() => setPageNumber(pageNumber + 1)}
                        disabled={!nextPage}
                        style={{
                            cursor: nextPage ? 'pointer' : 'not-allowed',
                        }}
                    >
                        →
                    </button>
                </div>
            </div>
        </>
    )
}
